import { render, staticRenderFns } from "./DisplayCamps.vue?vue&type=template&id=3fc38cdc"
import script from "./DisplayCamps.vue?vue&type=script&lang=js"
export * from "./DisplayCamps.vue?vue&type=script&lang=js"
import style0 from "./DisplayCamps.vue?vue&type=style&index=0&id=3fc38cdc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports